import {NgModule} from '@angular/core';
import {downgradeComponent} from '@angular/upgrade/static';
import * as angular from 'angular';
import {ProfileSettingsComponent} from './profile-settings/profile-settings.component';
import {
  AcceptReturnDialogComponent,
  ProfileSettingsFormComponent
} from './profile-settings/profile-settings-form/profile-settings-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatChipsModule
} from '@angular/material';
import {CommonModule} from '@angular/common';
import {TextMaskModule} from 'angular2-text-mask';

@NgModule({
  declarations: [
    ProfileSettingsComponent,
    ProfileSettingsFormComponent,
    AcceptReturnDialogComponent,
],
  entryComponents: [
    ProfileSettingsComponent,
    ProfileSettingsFormComponent,
    AcceptReturnDialogComponent,
],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    TextMaskModule
], })
export class SettingsModule { }

try {
  angular.module('mandaeApp')
    .directive('appProfileSettings', downgradeComponent({ component: ProfileSettingsComponent }));
} catch (e) {}
